import React, { useCallback, useState } from 'react';
import { useHits, useRefinementList } from 'react-instantsearch-hooks-web';
import { useMemberExperienceAuth } from '@guildeducationinc/auth-frontend-tools';
import { Accordion, Typography } from '@guildeducationinc/recess';
import { RefinementListFacetValueSet } from 'src/components/RefinementListFacetValueSet';
import { useSearchContext } from '@src/components/Providers/SearchProvider';
import { formatMoney } from '@src/utilities/numberFormattingUtility';
import { useDecision } from '@optimizely/react-sdk';
import { ROLE_MAPPING } from '@src/constants/featureFlags';
import { trackFilterEvents } from '../filterHelpers';

export const FundingLevelFilter: React.FC = () => {
	const [rolesDecision] = useDecision(ROLE_MAPPING);
	const [toggleAccordion, setToggleAccordion] = useState<boolean>(!rolesDecision?.enabled);
	const [selectedChildrenFilterCount, setSelectedChildrenFilterCount] = useState<number>(0);

	const sortByName = useCallback((a, b) => {
		return a.name.toUpperCase() < b.name.toUpperCase() ? -1 : 1;
	}, []);

	const { items, refine } = useRefinementList({
		attribute: 'fundingLevel',
		sortBy: sortByName,
	});

	const { results } = useHits();
	const { userFromIdToken: user } = useMemberExperienceAuth();
	const { index } = useSearchContext();
	const FilterTitle: React.FC = () => {
		const selectedFacetsCount = items.filter(facet => facet.isRefined).length;

		return (
			<Typography testid='funding-level-title' variant='h6'>{`Funding level ${
				selectedFacetsCount > 0 ? `(${selectedFacetsCount + selectedChildrenFilterCount})` : ''
			}`}</Typography>
		);
	};

	return (
		<Accordion
			defaultOpen={toggleAccordion}
			testid='fundingLevelFilterAccordion'
			title={FilterTitle}
		>
			{items.map(facet => (
				<div key={facet.label}>
					<RefinementListFacetValueSet
						categoryLabel={
							facet.label === '-1'
								? '100% tuition paid'
								: `Up to ${formatMoney(facet.label)} tuition paid per year`
						}
						facet={facet}
						onChange={facetValue => {
							refine(facetValue);
							setToggleAccordion(true);
							const eventName = facet.isRefined ? 'FilterRemoved' : 'FilterAdded';
							trackFilterEvents(
								'fundingLevel',
								eventName,
								'fundingLevel',
								facetValue,
								index,
								results,
								user
							);
						}}
						setSelectedChildrenFilterCount={setSelectedChildrenFilterCount}
					/>
				</div>
			))}
		</Accordion>
	);
};
